// START IMPORTS
import { Header } from '@ltvco/refresh-lib/v2';
// END IMPORTS

// START INTERFACES_AND_TYPES
type HeaderParentProps = {
  handleSearchSuccess: any;
};
// END INTERFACES_AND_TYPES

export const HeaderParent = ({ handleSearchSuccess }: HeaderParentProps) => {
  // START RENDER
  return <Header onSearchSuccess={handleSearchSuccess} />;
  // END RENDER
};
